import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const CircleCheckmarkOutlined = ({
  color = 'black90',
  width = 22,
  marginLeft,
  marginRight,
  containerSize,
}: DefaultIconProps) => {
  return (
    <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={Number(width)}
        height={Number(width)}
        viewBox="0 0 22 22"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21ZM11 19.5C15.6944 19.5 19.5 15.6944 19.5 11C19.5 6.30558 15.6944 2.5 11 2.5C6.30558 2.5 2.5 6.30558 2.5 11C2.5 15.6944 6.30558 19.5 11 19.5Z"
          fill={getSemanticTextColor(color)}
        />
        <path
          d="M14.8532 8.61114L14.8544 8.61221C15.0205 8.75928 15.0457 9.00738 14.9237 9.18066L14.8884 9.22046L10.2279 14.3524L10.2266 14.3538C10.0664 14.5316 9.78492 14.5509 9.59344 14.392L9.56206 14.3567L9.5621 14.3566L9.55717 14.3513L7.11032 11.6739L7.10981 11.6733C6.95307 11.5023 6.96292 11.2338 7.14789 11.0684C7.31869 10.9177 7.58434 10.9191 7.75469 11.072L7.79778 11.1145L9.51923 13.0094L9.88938 13.4168L10.2595 13.0093L14.2191 8.64928C14.2193 8.64904 14.2195 8.64881 14.2197 8.64857C14.3899 8.46375 14.6742 8.45163 14.8532 8.61114Z"
          fill={getSemanticTextColor(color)}
          stroke={getSemanticTextColor(color)}
        />
      </svg>
    </DefaultIconWrapper>
  );
};
